export const SIGN_UP_TO_POST_URL_FOR_LOCALE = {
  en: '/sign-up-to-post',
  es: '/es/orgs/registrate',
  pt: '/anuncie',
};
